import React from 'react';
import { cn } from 'shared/lib/cn';

export type Toggle2Props = {
  leftLabel: string;
  rightLabel: string;
  isRightActive: boolean;
  onToggle: () => void;
  ariaLabel: string;
  forceRight?: boolean;
  disabled?: boolean;
  /** Why the switch is disabled, shown as the native tooltip. forceRight has its own. */
  title?: string;
  className?: string;
};

/** Two-sided switch (replaces components/ui/toggle.tsx). forceRight pins right and disables. */
export function Toggle2({ leftLabel, rightLabel, isRightActive, onToggle, ariaLabel, forceRight = false, disabled = false, title, className }: Toggle2Props) {
  const right = forceRight ? true : isRightActive;
  const isDisabled = disabled || forceRight;
  return (
    <div className={cn('inline-flex items-center gap-2 font-body text-sm', isDisabled && 'opacity-75', className)}>
      <span className={cn(!right ? 'text-ink' : 'text-ink-muted')}>{leftLabel}</span>
      <button
        type="button"
        role="switch"
        aria-checked={right}
        aria-label={ariaLabel}
        disabled={isDisabled}
        title={forceRight ? 'Pinned by the selected vendor' : title}
        onClick={isDisabled ? undefined : onToggle}
        className={cn(
          'relative inline-flex h-5 w-9 items-center rounded-full border border-hairline/30 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand/60',
          right ? 'bg-brand' : 'bg-surface-high',
          isDisabled && 'cursor-not-allowed',
        )}
      >
        <span className={cn('inline-block h-4 w-4 rounded-full bg-ink transition-transform', right ? 'translate-x-4' : 'translate-x-0.5')} />
      </button>
      <span className={cn(right ? 'text-ink' : 'text-ink-muted')}>{rightLabel}</span>
    </div>
  );
}
